var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipeCardSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M720 4867 c-49 -16 -133 -102 -148 -153 -17 -60 -17 -3208 0 -3268 16 -55 99 -138 154 -154 30 -9 166 -12 488 -12 l446 0 0 -24 c0 -14 -11 -130 -25 -258 -37 -342 -34 -372 34 -451 65 -74 13 -65 1221 -192 687 -72 1121 -114 1147 -110 66 10 133 60 165 125 27 54 31 85 194 1634 109 1033 164 1594 159 1622 -10 67 -60 134 -125 166 -52 26 -84 30 -631 88 -317 33 -582 60 -588 60 -8 0 -11 103 -11 366 0 259 -4 379 -12 408 -16 55 -99 138 -154 154 -56 16 -2261 16 -2314 -1z m2295 -172 l25 -24 0 -356 c0 -195 -4 -355 -8 -355 -5 0 -202 21 -438 46 -239 25 -444 42 -464 39 -74 -14 -140 -64 -175 -135 -14 -26 -46 -302 -146 -1250 -70 -668 -128 -1216 -128 -1217 -1 -2 -206 -3 -456 -3 l-456 0 -24 25 -25 24 0 1591 0 1591 25 24 24 25 1111 0 1111 0 24 -25z m248 -920 l1092 -114 23 -26 c12 -14 22 -31 22 -38 0 -7 -74 -718 -165 -1582 l-165 -1570 -25 -22 c-15 -13 -32 -23 -40 -23 -18 0 -2093 217 -2153 226 -53 7 -82 33 -82 77 -1 17 72 730 162 1582 l162 1550 27 28 c15 15 32 27 38 27 6 0 503 -52 1104 -115z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeCardSvg);
export default __webpack_public_path__ + "static/media/swipe-card-svg.6c07ccc806e493dd8ef2ec912a5893e2.svg";
export { ForwardRef as ReactComponent };